import { render, staticRenderFns } from "./HowWorkCard.vue?vue&type=template&id=6ec3866f&scoped=true&"
import script from "./HowWorkCard.vue?vue&type=script&lang=js&"
export * from "./HowWorkCard.vue?vue&type=script&lang=js&"
import style0 from "./HowWorkCard.vue?vue&type=style&index=0&id=6ec3866f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec3866f",
  null
  
)

export default component.exports